import { AnyAction } from 'redux'

import { banner as actions } from '../actions'

export const initialState = {
  open: false
}

interface IBanner {
  open: boolean
  error?: boolean
  assertive: boolean
  msg: string
  type?: 'error'
}

export const setBanner =
  (data: IBanner) => (dispatch: (x: AnyAction) => $TSFixMe) =>
    dispatch({
      type: actions.SET_BANNER,
      data: {
        ...data,
        // set assertive to `false` if not specified
        assertive: !!data.assertive,
        // use default type if not specified
        type: data.type || null
      }
    })
